import type { FormSegment } from '../../../../../../../../../modules/audiences/AudienceForm/types';

type BuildSegmentMaps = {
  districtsByParentId: Map<string, FormSegment[]>;
  uniqueParentIds: Set<string>;
};

export const buildSegmentMaps = (segments: FormSegment[]): BuildSegmentMaps => {
  const districtsByParentId = new Map<string, FormSegment[]>();
  const uniqueParentIds = new Set<string>();

  segments.forEach(segment => {
    uniqueParentIds.add(segment.parent_segment);

    if (!districtsByParentId.has(segment.parent_segment)) {
      districtsByParentId.set(segment.parent_segment, []);
    }

    districtsByParentId.get(segment.parent_segment)!.push(segment);
  });

  return {
    districtsByParentId,
    uniqueParentIds,
  };
};
